// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_FEATURED_PRODUCTS: `${environment.apiUrl}/products/featured`,
});

export const getFeaturedProductsApi = getCreator(fetch, endpoints.GET_FEATURED_PRODUCTS);



// WEBPACK FOOTER //
// ./src/modules/featured-products/api.js